module.exports = __webpack_public_path__ + "static/tr2-ae63ea614b68b623e1c3f2f5da5fce54.jpg";